namespace appn.views.provider.createOrEdit {

    class InitArgs {
        shortDateFormatDefault: string = appn.emptyString;
        shortTimeFormatDefault: string = appn.emptyString;
    }

    let _initArgs: InitArgs;

    export function init(args: InitArgs): void {
        _initArgs = args;

        const shortDateFormat = $('#Provider_ProviderConfig_ShortDateFormat');
        const shortTimeFormat = $('#Provider_ProviderConfig_ShortTimeFormat');

        appn.services.validateDateFormat((shortDateFormat.val() as string), $('#dateFormatResult'));
        appn.services.validateDateFormat((shortTimeFormat.val() as string), $('#timeFormatResult'));

        addEvents(shortDateFormat, shortTimeFormat);
    }

    function addEvents(shortDateFormat: JQuery<HTMLElement>, shortTimeFormat: JQuery<HTMLElement>) {
        shortDateFormat.change(function(event) {
            if (!shortDateFormat.val())
                shortDateFormat.val(_initArgs.shortDateFormatDefault);

            appn.services.validateDateFormat((shortDateFormat.val() as string), $('#dateFormatResult'));
        });

        shortTimeFormat.change(function(event) {
            if (!shortTimeFormat.val())
                shortTimeFormat.val(_initArgs.shortTimeFormatDefault);

            appn.services.validateDateFormat((shortTimeFormat.val() as string), $('#timeFormatResult'));
        });
    }
}

